<div class="theme-primary">
	<div class="modal-header theme-accent-bg theme-primary-font-border-fade-50">
		<h3 class="theme-accent-txt" id="modal-title">
			{{ 'Event_VideoSource_Restart_Dialog_Title' | translate }}
		</h3>
	</div>

	<div class="modal-body">
		<p>
			{{ 'Event_VideoSource_Restart_Dialog_Message' | translate }}
		</p>
		<vb-ui-form-group>
			<label for="audMessage" #uiLabel>
				{{ 'Event_VideoSource_Restart_Dialog_AudienceMessage' | translate }}
			</label>
			<textarea [(ngModel)]="audienceMessage" name="audMessage" rows="2" uiControl vbAutoFocus vbUiTextArea [height]="60">
			</textarea>
		</vb-ui-form-group>

	</div>
	<div class="modal-footer">
		<button type="button" vbBtnSecondary (click)="close()">{{ 'Cancel' | translate }}</button>
		<button type="button" vbBtnPrimary (click)="restartSource()">{{ 'Restart' | translate }}</button>
	</div>
</div>
